import { render, staticRenderFns } from "./NumberOfContEducation.vue?vue&type=template&id=bae62aa0&"
import script from "./NumberOfContEducation.vue?vue&type=script&lang=js&"
export * from "./NumberOfContEducation.vue?vue&type=script&lang=js&"
import style0 from "./NumberOfContEducation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports